<template>
<div>
  <div class="form-group form-group-default form-multiselect">
    <label>{{ $t("models.user.civility") }}</label>
    <multiselect
      v-model="internalValue.civility"
      @input="onChange('civility', $event)"
      :options="civilityOptions"
      :searchable="false"
      :placeholder="$t('multiselect.civility')"
      :showLabels="false"
      :allow-empty="true">
    </multiselect>
  </div>

  <div class="d-flex flex-row align-items-center">
    <label class="mr-4">{{ $t('models.user.birthdate') }}</label>
    <date-picker v-model="internalValue.birthdate_display"
                 @input="onChange('birthdate_display', $event)"
                 :datepickerOptions="datepickerDefaultOptions"
                 :disabledToday="true"
                 class="birthdate-picker" />
  </div>

  <div class="form-group form-group-default">
    <label>{{ $t("models.user.birthplace") }}</label>
    <input v-model="internalValue.birthplace"
           @input="onChange('birthplace', $event.target.value)"
           name="birthplace"
           type="text"
           class="form-control">
  </div>

  <div class="form-group form-group-default">
    <label>{{ $t("models.user.address") }}</label>
    <input v-model="internalValue.address"
           @input="onChange('address', $event.target.value)"
           name="address"
           type="text"
           class="form-control">
  </div>

  <div class="form-group form-group-default">
    <label>{{ $t("models.user.social_security_number") }}</label>
    <input v-model="internalValue.social_security_number"
           @input="onChange('social_security_number', $event.target.value)"
           name="socialSecurityNumber"
           type="text"
           class="form-control">
  </div>

  <div class="form-group form-group-default">
    <label>{{ $t("models.user.salary_category") }}</label>
    <input v-model="internalValue.salary_category"
           @input="onChange('salary_category', $event.target.value)"
           name="salaryCategory"
           type="text"
           class="form-control">
  </div>

  <div class="form-group form-group-default">
    <label>{{ $t("models.user.salary") }}</label>
    <input v-model="internalValue.salary"
           @input="onChange('salary', $event.target.value)"
           name="salary"
           type="text"
           class="form-control">
  </div>

  <div class="form-group form-group-default">
    <label>{{ $t("models.user.n_dpae") }}</label>
    <input v-model="internalValue.n_dpae"
           @input="onChange('n_dpae', $event.target.value)"
           name="n_dpae"
           type="text"
           class="form-control">
  </div>
</div>
</template>

<script>
import DatePicker from '@/components/pages/DatePicker'

export default {
  name: 'ContractFields',
  components: { DatePicker },
  props: ['value'],
  data() {
    return {
      internalValue: Object.assign({}, this.value),
      civilityOptions: [this.$i18n.t("models.user.mrs"), this.$i18n.t("models.user.mr")],
      datepickerDefaultOptions: {
        startDate: new Date(1900, 1, 1)
      },
    }
  },
  watch: {
    value: {
      handler() {
        this.internalValue = Object.assign({}, this.value)
      }
    }
  },
  methods: {
    onChange(field, value) {
      this.$emit('change', { field: field, value: value })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/users/form/ContractFields.vue